import { roundToScale } from './roundToScale'

type Input = Parameters<typeof roundToScale>[0]

export const roundBillingRands = <T extends Input>(value: T) => roundToScale(value, 4)
